import {
  Divider,
  IconButton,
  KeyboardArrowDownRoundedIcon,
  Menu,
  MenuItem,
  styled,
} from '@shared/components';
import type { Commands } from '@tiptap/core';
import { useState } from 'react';

import { useRichTextEditor } from '../../providers';

type TableOperation = Extract<
  keyof Commands['table'],
  | 'addColumnBefore'
  | 'addColumnAfter'
  | 'addRowBefore'
  | 'addRowAfter'
  | 'deleteTable'
  | 'toggleHeaderRow'
  | 'toggleHeaderColumn'
  | 'deleteColumn'
  | 'deleteRow'
>;

const StyledIconButton = styled(IconButton)({
  opacity: 0,
  position: 'absolute',
  top: 4,
  right: 4,
  transition: 'opacity 0.2s',

  '.tiptap-table-cell:hover &': {
    opacity: 1,
  },
});

export default function TableCellMenu() {
  const { editor } = useRichTextEditor();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!editor) {
    return null;
  }

  const isOpen = anchorEl !== null;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTableOperation = (operation: TableOperation) => {
    editor.chain().focus()[operation]().run();
    handleClose();
  };

  return (
    <>
      <StyledIconButton size='small' onClick={handleClick} className='table-cell-menu'>
        <KeyboardArrowDownRoundedIcon fontSize='small' />
      </StyledIconButton>
      <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        <MenuItem onClick={() => handleTableOperation('toggleHeaderRow')}>
          Toggle Header Row
        </MenuItem>
        <MenuItem onClick={() => handleTableOperation('toggleHeaderColumn')}>
          Toggle Header Column
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleTableOperation('addColumnBefore')}>
          Insert Column Before
        </MenuItem>
        <MenuItem onClick={() => handleTableOperation('addColumnAfter')}>
          Insert Column After
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleTableOperation('addRowBefore')}>Insert Row Before</MenuItem>
        <MenuItem onClick={() => handleTableOperation('addRowAfter')}>Insert Row After</MenuItem>
        <Divider />
        <MenuItem onClick={() => handleTableOperation('deleteTable')}>Delete Table</MenuItem>
        <MenuItem onClick={() => handleTableOperation('deleteColumn')}>Delete Column</MenuItem>
        <MenuItem onClick={() => handleTableOperation('deleteRow')}>Delete Row</MenuItem>
      </Menu>
    </>
  );
}
